module.exports = __webpack_public_path__ + "img/logo-ocean-plus-library.a8710763.svg";